import apiHandler from "../core/apiHandler";

const taxpayerCategoryApi = apiHandler('taxpayer-categories');
export default taxpayerCategoryApi;